import {Routes} from '@angular/router';
import {
  ApplicantDataComponentConfig,
  ApplicantDataSectionComponent
} from '../common/applicant-data-section/applicant-data-section.component';
import {
  ResponseToCallAnswerSectionComponent
} from './sections/response-to-call-answer-section/response-to-call-answer-section.component';
import {
  AttachmentDataComponentConfig,
  AttachmentsDataSectionComponent
} from '../common/attachments-data-section/attachments-data-section.component';
import {
  AgreementsDataComponentConfig,
  AgreementsDataSectionComponent
} from '../common/agreements-data-section/agreements-data-section.component';
import {SessionService} from '../../../../services/ssession.service';

export const desktopStages: string[] = [
  'Wnioskodawca',
  'Dane wniosku',
  'Odpowiedź',
  'Zgody',
  'Załączniki'
];

export const mobileStages: string[] = [
  'Wnioskodawca',
  'Dane wniosku',
  'Odpowiedź',
  'Zgody',
  'Załączniki'
];

export const stages: string[] = SessionService.GetUISettings()?.mobileEmbed ? mobileStages : desktopStages;

export const applicantDataSectionConfig: ApplicantDataComponentConfig = {
  stages,
  successUrl: '../odpowiedz'
};

export const agreementsDataSectionConfig: AgreementsDataComponentConfig = {
  stages,
  cancelUrl: '../odpowiedz',
  successUrl: '../zalaczniki'
};

export const attachmentDataSectionConfig: AttachmentDataComponentConfig = {
  stages,
  cancelUrl: '../zgody'
};

export const responseToCallDesktopRoutes: Routes = [
  {
    component: ApplicantDataSectionComponent,
    path: 'wnioskodawca',
    data: applicantDataSectionConfig
  },
  {
    component: ApplicantDataSectionComponent,
    path: ':appId/wnioskodawca',
    data: applicantDataSectionConfig
  },
  {
    component: ResponseToCallAnswerSectionComponent,
    path: ':appId/odpowiedz',
    data: {
      successUrl: '../zgody'
    }
  },
  {
    path: ':appId/zgody',
    component: AgreementsDataSectionComponent,
    data: agreementsDataSectionConfig
  },
  {
    component: AttachmentsDataSectionComponent,
    path: ':appId/zalaczniki',
    data: attachmentDataSectionConfig
  },
  {path: '', redirectTo: 'wnioskodawca', pathMatch: 'prefix'}
];

export const responseToCallMobileRoutes: Routes = [
  {
    component: ApplicantDataSectionComponent,
    path: 'wnioskodawca',
    data: applicantDataSectionConfig
  },
  {
    component: ApplicantDataSectionComponent,
    path: ':appId/wnioskodawca',
    data: applicantDataSectionConfig
  },
  {
    component: ResponseToCallAnswerSectionComponent,
    path: ':appId/odpowiedz',
    data: {
      successUrl: '../zgody'
    }
  },
  {
    path: ':appId/zgody',
    component: AgreementsDataSectionComponent,
    data: {
      ...agreementsDataSectionConfig,
      removeRegulationsControl: true
    }
  },
  {
    component: AttachmentsDataSectionComponent,
    path: ':appId/zalaczniki',
    data: attachmentDataSectionConfig
  },
  {path: '', redirectTo: 'wnioskodawca', pathMatch: 'prefix'}
];

export const responseToCallRoutes: Routes = SessionService.GetUISettings()?.mobileEmbed ? responseToCallMobileRoutes : responseToCallDesktopRoutes;
